import { configureStore } from '@reduxjs/toolkit';
import userInfoReducer from '../features/userInfo/userInfoSlice'
import osheeReducer from '../features/userInfo/osheeSlice'
import topUpReducer from '../features/userInfo/topUpSlice'
import registrationReducer from '../features/registration/registrationSlice'
import loginReducer from '../features/login/loginSlice'
import taksatVendoreReducer from '../features/taksatVendoreSlice.js/taksatVendoreSlice'
import globalDataReducer from '../features/global/globalDataSlice'
import myContractsReducer from '../features/myContracts/myContractsSlice'
import utilityReducer from '../features/utilities/utilitySlice'
import paymentsReducer from '../features/payments/paymentsSlice'
import taksatReducer from '../features/taksat/taksatSlice'
import digitalbReducer from '../features/digitalb/digitalbSlice'
import basicAccountReducer from '../features/basicAccount/basicAccountSlice'
import albtelecomMobileReducer from '../features/albtelecomMobile/albtelecomMobileSlice'
import oneReducer from '../features/oneMobile/oneSlice'
import vodafoneInvoicesReducer from '../features/vodafone/vodafoneInvoicesSlice'
import p2pReducer from '../features/p2p/p2pSlice'
import vodafoneTopupReducer from '../features/vodafone/vodafoneTopupSlice'
import forgotUserAccountReducer from '../features/login/forgotUserAccountSlice';
import forgotPasswordReducer from '../features/resetPassword/forgotPasswordSlice'
import termsAndConditionsReducer from '../features/termsAndConditions/termsAndConditionsSlice'
import popularQuestionsReducer from '../features/popularQuestions/popularQuestionsSlice'
import exchangeReducer from '../features/exchange/exchangeSlice'
import { combineReducers } from '@reduxjs/toolkit';
import { createFilter, createBlacklistFilter  } from 'redux-persist-transform-filter';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'


const appReducer = combineReducers({login: loginReducer , termsAndConditions: termsAndConditionsReducer, basicAccount: basicAccountReducer, registration: registrationReducer, topUp: topUpReducer, userInfo: userInfoReducer, oshee: osheeReducer, globalData: globalDataReducer, myContracts: myContractsReducer, utility: utilityReducer, payments: paymentsReducer, p2p: p2pReducer, taksat: taksatReducer, digitalb: digitalbReducer, albtelecomMobile: albtelecomMobileReducer, forgotPassword: forgotPasswordReducer, forgotUserAccount: forgotUserAccountReducer, one: oneReducer, vodafoneInvoices: vodafoneInvoicesReducer, vodafoneTopup: vodafoneTopupReducer, popularQuestions: popularQuestionsReducer, exchange: exchangeReducer, taksatVendore: taksatVendoreReducer})

const globalDataSubFilter = createBlacklistFilter('globalData', ['isLoading']);
const userInfoSubFilter = createBlacklistFilter('userInfo', ['isLoading']);
const paymentsSubFilter = createBlacklistFilter('payments,'['isLoading'])

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist:['globalData','userInfo','payments'],
  // blacklist:['userInfo'],
  transforms:[globalDataSubFilter,userInfoSubFilter, paymentsSubFilter]
}
const rootReducer = (state, action) => 
{
  if(action.type === 'USER_LOGOUT')
  {
    storage.removeItem('persist:root')
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store)